import { render, staticRenderFns } from "./VMaskField.vue?vue&type=template&id=a85d123e&scoped=true"
import script from "./VMaskField.vue?vue&type=script&lang=ts"
export * from "./VMaskField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85d123e",
  null
  
)

export default component.exports